export interface MesReferenciaOption {
  valor: number;
  descricao: string;
}

export const MESES_REFERENCIA: MesReferenciaOption[] = [
  { valor: 1, descricao: 'Janeiro' },
  { valor: 2, descricao: 'Fevereiro' },
  { valor: 3, descricao: 'Março' },
  { valor: 4, descricao: 'Abril' },
  { valor: 5, descricao: 'Maio' },
  { valor: 6, descricao: 'Junho' },
  { valor: 7, descricao: 'Julho' },
  { valor: 8, descricao: 'Agosto' },
  { valor: 9, descricao: 'Setembro' },
  { valor: 10, descricao: 'Outubro' },
  { valor: 11, descricao: 'Novembro' },
  { valor: 12, descricao: 'Dezembro' }
];

export const QUANTIDADE_ANOS_ANTERIORES = 5;

export function gerarAnosReferencia(anoAtual: number = new Date().getFullYear()): number[] {
  const anos: number[] = [];
  for (let ano = anoAtual; ano >= anoAtual - QUANTIDADE_ANOS_ANTERIORES; ano--) {
    anos.push(ano);
  }
  return anos;
}
